var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 10.2812C20.4062 11.9375 20.4062 14.5938 18.75 16.25L15.25 19.7812C14.9688 20.0938 14.5 20.0938 14.1875 19.8125C13.9062 19.5 13.9062 19.0312 14.1875 18.75L17.6875 15.1875C18.75 14.125 18.75 12.4062 17.6875 11.3438L13.6875 7.28125C13.4062 7 13.4062 6.53125 13.7188 6.21875C14 5.9375 14.4688 5.9375 14.75 6.25L18.75 10.2812ZM8.5 9.5C8.5 10.0625 8.03125 10.5 7.5 10.5C6.9375 10.5 6.5 10.0625 6.5 9.5C6.5 8.96875 6.9375 8.5 7.5 8.5C8.03125 8.5 8.5 8.96875 8.5 9.5ZM16.8125 11.8438C17.5938 12.625 17.5938 13.9062 16.8125 14.6875L12.6562 18.8438C11.875 19.625 10.5938 19.625 9.8125 18.8438L4.5625 13.5938C4.1875 13.2188 4 12.7188 4 12.1875V7.5C4 6.6875 4.65625 6 5.5 6H10.1562C10.6875 6 11.1875 6.21875 11.5625 6.59375L16.8125 11.8438ZM5.5 7.5V12.1875C5.5 12.3125 5.53125 12.4375 5.625 12.5312L10.875 17.7812C11.0625 18 11.4062 18 11.5938 17.7812L15.75 13.625C15.9688 13.4375 15.9688 13.0938 15.75 12.9062L10.5 7.65625C10.4062 7.5625 10.2812 7.5 10.1562 7.5H5.5Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabels);
export default __webpack_public_path__ + "static/media/Labels.7b07778dda0c9f6fbafc465e69077cf7.svg";
export { ForwardRef as ReactComponent };